import { Alert, Button, Form, Icon, Input } from "antd";
import React, { useState } from "react";
import { EaseModal } from "../../../../../libs/EaseModal";
import { Text1 } from "../../../../../styles";
import { GstConfigForm } from "../../Forms";

const GstConfigModal = (props) => {
  const renderTitle = () => {
    return (
      <Text1 className="d-block mb-4" strong>
        GST Payment Setup
      </Text1>
    );
  };

  return (
    <EaseModal
      width={550}
      title={false}
      visible={props.visible}
      onCancel={props.toggleGSTModal}
      centered
      hideFooter
      destroyOnClose
    >
      {renderTitle()}
      <Alert
        description="We will fetch challan from the GST portal for the below entered GST Numbers. Make sure to enter valid GST numbers."
        type='info'
        showIcon
        closable
        className="mb-3"
      />
      <GstConfigForm
        gst={props.gst}
        onSubmit={props.createGST}
        loading={props.loading}
      />
    </EaseModal>
  );
};

export default GstConfigModal;
